(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/utils/utils.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/utils/utils.js');
"use strict";

var _svs, _svs2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$iam_idp$constant = svs.iam_idp.constants,
  POST_MESSAGE_TYPES = _svs$iam_idp$constant.POST_MESSAGE_TYPES,
  loginMethods = _svs$iam_idp$constant.loginMethods;
const TARGET_ORIGIN = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.iam_idp) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.origins) === null || _svs === void 0 ? void 0 : _svs.target;
const TRUSTED_ORIGIN = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.iam_idp) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.origins) === null || _svs2 === void 0 ? void 0 : _svs2.trusted;
const POST_MESSAGE_SOURCE = 'svs-iam-iframe';
const isInIamIframe = window.self !== window.top;
const postMessageToParent = message => {
  if (Object.values(POST_MESSAGE_TYPES).includes(message.type)) {
    window.parent.postMessage(_objectSpread(_objectSpread({}, message), {}, {
      source: POST_MESSAGE_SOURCE,
      messageType: message.type,
      type: undefined
    }), TARGET_ORIGIN);
  }
};

const awaitPostMessageToParent = (message, responseType) => {
  const generateRequestId = () => "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
  return new Promise(resolve => {
    const requestId = generateRequestId();
    function handleMessage(event) {
      if (event.origin === TARGET_ORIGIN && event.data && event.data.requestId === requestId && event.data.messageType === responseType) {
        window.removeEventListener('message', handleMessage);
        resolve(event.data.value);
      }
    }
    window.addEventListener('message', handleMessage);

    postMessageToParent(_objectSpread(_objectSpread({}, message), {}, {
      requestId
    }));
  });
};
const updateParentQuerystring = async queryData => await awaitPostMessageToParent({
  type: POST_MESSAGE_TYPES.UPDATE_PARENT_QUERYSTRING,
  value: {
    queryData
  }
}, POST_MESSAGE_TYPES.PARENT_QUERYSTRING_UPDATED);
const parentTrackEvent = trackingObject => {
  if (isInIamIframe) {
    return new Promise(resolve => {
      const requestId = "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
      let resolved = false;
      function handler(event) {
        if ((event.origin === TRUSTED_ORIGIN || event.origin === window.location.origin) && event.data && event.data.source === 'svs-iam-parent' && event.data.requestId === requestId && event.data.messageType === POST_MESSAGE_TYPES.PARENT_TRACK_EVENT_RESOLVED) {
          window.removeEventListener('message', handler);
          resolved = true;
          resolve();
        }
      }
      window.addEventListener('message', handler);
      postMessageToParent({
        type: POST_MESSAGE_TYPES.PARENT_TRACK_EVENT,
        value: trackingObject,
        requestId
      });
      setTimeout(() => {
        if (!resolved) {
          window.removeEventListener('message', handler);
          resolve();
        }
      }, 2000);
    });
  }
  return new Promise(resolve => {
    svs.components.analytics.trackEvent(trackingObject, () => {
      resolve();
    });
  });
};
const setFullscreen = () => {
  postMessageToParent({
    type: POST_MESSAGE_TYPES.FULLSCREEN
  });
};

const getIAMData = () => new Promise((resolve, reject) => {
  svs.core.deviceSession.get('parameters', 'iam', (result, error) => {
    if (error) {
      reject(error);
    } else {
      resolve(result || {});
    }
  });
});

const setIAMData = data => new Promise((resolve, reject) => {
  svs.core.deviceSession.set('parameters', 'iam', data, error => {
    if (error) {
      reject(error);
    } else {
      resolve(data || {});
    }
  });
});

const updateIAMData = async newData => {
  const iamData = await getIAMData();
  const updatedData = _objectSpread(_objectSpread({}, iamData), newData);
  await setIAMData(updatedData);
  return updatedData;
};

const setLoginMethodInDeviceSession = method => new Promise((resolve, reject) => {
  svs.core.deviceSession.set('loginType', 'iam', method, error => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });
});
svs.iam_idp.utils = {
  setFullscreen,
  getIAMData,
  setIAMData,
  updateIAMData,
  postMessageToParent,
  isInIamIframe,
  parentTrackEvent,
  setLoginMethodInDeviceSession,
  updateParentQuerystring
};

 })(window);